module.exports = __webpack_public_path__ + "static/media/logo-silestone.a1ec5afd.svg";